<template>
  <div class="z-card py-0 border-0 px-5 mb-4">
    <h2 class="z-card__title mt-5">
      {{ $t('shared.tasks') }}
    </h2>

    <div class="z-card__body" style="position: relative">
      <div class="circle-row">
        <template v-for="(item, i) in total">
          <div v-if="total.length-1 != i" :key="i" :class="`circle-row__item circle-row__item--${Object.values(item)[1]}`">
            <span>{{ Object.keys(item)[0] }}</span>
            <span>{{ Object.values(item)[0] }}</span>
          </div>
        </template>
        <stat-total-circle :data="circle_total">
          <span slot="title">{{ $t('voice.stats.general.field.total') }}</span>
          <span slot="amount"> {{ circle_amount_total }}</span>
        </stat-total-circle>
      </div>
      <column-chart :data="chart_data" :options="chart_options" />
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import ColumnChart from '@shared/components/stats-chart-column';
  import StatTotalCircle from '@shared/components/stats-chart-cicle-total';
  import { blue, purple, blue_grey, grey, red, green, yellow, orange, crimson } from '@shared/helpers/css';
  import { DATA } from '@/plugins/vuex-async-pagginate';

  export default {
    components: {
      ColumnChart,
      StatTotalCircle
    },
    data() {
      return {
        colors: [
          'green',
          'blue', 
          'red',
          'yellow',
          'purple',
          'blue_grey',
          'grey',
          'orange',
          'crimson'
        ]
      }
    },
    filters: {
      format: function(val) {
        return parseInt(val).toLocaleString();
      }
    },

    computed: {
      ...mapGetters('stats/table', { items: DATA }),
      stat() {
        let s = []
        for (let key in this.items[0]) {
          if(key == 'Всего') continue
          s.push(key)
        }
        return s;
      },
      chart_options() {
        return {
          series: {
            0: { color: green },
            1: { color: blue },
            2: { color: yellow },
            3: { color: red },
            4: { color: purple },
            5: { color: blue_grey },
            6: { color: grey },
            7: { color: orange },
            8: { color: crimson }
          }
        };
      },
      columns() {
        return [
          ...this.stat
        ];
      },

      chart_data() {
        if(this.items.length) {
          if( 'tasks' in this.items[0]) {
            if(this.items[0].tasks != 'undefined') {
              let arr = this.items;
              for (let i = 0; i < arr.length; i++) {
                var result = {};
                result[' '] = arr[i]['group_by'] ? arr[i]['group_by'] : 'Без исполнителя';
                for (let j=0;j<arr[i].tasks.length;j++) {
                  result[arr[i].tasks[j].caption] = arr[i].tasks[j].quantity;
                }
                result['Всего'] = arr[i]['total']
                arr[i] = result
              }
              const values = arr.map(i=>this.stat.map(function(s) {
                return i[s]
              }))
              return [this.columns, ...values];
            }
          }
        }
        return null;        
      },

      total: function() {
        let arr = JSON.parse(JSON.stringify(this.items));
        for (let i = 0; i < arr.length; i++) {
          var result = {};
          if(!('tasks' in arr[i])) return;
          for (let j=0;j<arr[i].tasks.length;j++) {
            result[arr[i].tasks[j].caption] = arr[i].tasks[j].quantity;
          }
          result['total'] = arr[i]['total']
          arr[i] = result
        }
        let total_items =  arr.reduce((acc, n) => (Object.entries(n).forEach( ([k, v]) => acc[k] = (acc[k] || 0) + v), acc), {})
        let circle_items = [];
        Object.keys(total_items).forEach((keys, index) => {
          circle_items.push({
            [keys]: total_items[keys],
            color: this.colors[index]
          })
        });
        return circle_items;
      },
      circle_amount_total() {
        if(this.total && this.total.length) {
          return Object.values(this.total[this.total.length-1])[0];
        }
        return null;
      },
      circle_total: function() {
        let total = [['', '']]
        for (let k in this.total) {
          total.push(['', Object.values(this.total[k])[0]])
        }
        return total;
      }
    }
  };
</script>
